import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import {
  getCredit,
  getCreditNotFound,
  getSub,
  getAttSub,
  getTracfoneSub,
  getSimoSub,
  getQuickSub,
  getUser,
  getIncludedInGroups,
  getLoggedInUser,
} from '../reducers';

const withCredit = (DecoratedComponent) => {
  let WithCredit = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { creditId },
      },
    },
  ) => {
    const credit = getCredit(state, creditId);

    let carrier = '';
    let sub = '';
    let subId = '';
    let userId = '';

    if (credit && credit.subscription_id) {
      carrier = 'sprint';
      subId = credit.subscription_id;
      sub = getSub(state, subId);
    } else if (credit && credit.att_subscription_id) {
      carrier = 'att';
      subId = credit.att_subscription_id;
      sub = getAttSub(state, subId);
    } else if (credit && credit.tracfone_subscription_id) {
      carrier = 'tracfone';
      subId = credit.tracfone_subscription_id;
      sub = getTracfoneSub(state, subId);
    } else if (credit && credit.simo_subscription_id) {
      carrier = 'simo';
      subId = credit.simo_subscription_id;
      sub = getSimoSub(state, subId);
    } else if (credit && credit.quick_subscription_id) {
      carrier = 'quick';
      subId = credit.quick_subscription_id;
      sub = getQuickSub(state, subId);
    }

    if (credit && credit.user_profile) {
      userId = credit.user_profile;
    }

    return {
      loggedInUser: getLoggedInUser(state),
      credit,
      notFound: getCreditNotFound(state, creditId),
      creditId,
      carrier,
      subId,
      sub,
      userId,
      user: getUser(state, userId),
      isReseller: getIncludedInGroups(state, ['RESELLER']),
      isResellerOrAdminOrManager: getIncludedInGroups(state, [
        'RESELLER',
        'ADMIN',
        'MANAGER',
      ]),
    };
  };

  WithCredit = withRouter(connect(mapStateToProps, null)(WithCredit));

  const WithCreditRoute = ({ children, ...props }) => (
    <Route path="/credits/:creditId" component={WithCredit} {...props} />
  );

  return WithCreditRoute;
};

export default withCredit;
